import { render, staticRenderFns } from "./ItemsGroupArticle.vue?vue&type=template&id=1b34733a"
import script from "./ItemsGroupArticle.vue?vue&type=script&lang=js"
export * from "./ItemsGroupArticle.vue?vue&type=script&lang=js"
import style0 from "./ItemsGroupArticle.vue?vue&type=style&index=0&id=1b34733a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports